import { Injectable } from '@angular/core';

@Injectable()
export abstract class GegEvaluationScreenService {
    public abstract navigateBack(): void;
}
